import call from "./service/http";
import CheckoutConstant from "./constants";

export default {
  namespaced: true,
  state: {
    transactionStatus: "",
    message: "",
    transaction: {},
    statusTries: 0,
    cardResponse: "",
    balance: "",
    loading: false,
    iframePayload: {},
  },
  mutations: {
    SET_TRANSACTION_STATUS: (state, payload) => {
      state.transactionStatus = payload;
    },
    SET_IFRAME: (state, payload) => {
      state.iframePayload = payload;
    },

    RESET_STORE: (state) => {
      state.transactionStatus = "";
      state.message = "";
      state.transaction = {};
      iframePayload = {};
      state.statusTries = 0;
      state.cardResponse = "";
      state.balance = "";
      state.loading = false;
    },

    SET_TRANSACTION: (state, payload) => {
      state.transaction = payload;
    },

    SET_STATUS_TRIES: (state) => {
      state.statusTries++;
    },
    SET_MESSAGE: (state, payload) => {
      state.message = payload;
    },
    CARD_RESP: (state, payload) => {
      state.cardResponse = payload;
    },
    SET_BALANCE: (state, payload) => {
      state.balance = payload;
    },
    SET_LOADING: (state, payload) => {
      state.loading = payload;
    },
  },
  getters: {
    transactionStatus: (state) => state.transactionStatus,
    transaction: (state) => state.transaction,
    getIframe: (state) => state.iframePayload,
    message: (state) => state.message,
    cardResponse: (state) => state.cardResponse,
    balance: (state) => state.balance,
    loading: (state) => state.loading,
  },
  actions: {
    stkPush: ({ dispatch, commit }, payload) => {
      commit("SET_TRANSACTION_STATUS", "pending");
      commit("SET_LOADING", true);
      call("post", CheckoutConstant.stkPush, payload)
        .then((res) => {
          //wait 15 seconds to check status
          setTimeout(function () {
            dispatch("stkStatus", res.data.data.CheckoutRequestID);
          }, 3000);
          commit("SET_TRANSACTION", res.data.data);
        })
        .catch((error) => {
          commit("SET_MESSAGE", error.response.data.message);
          commit("SET_TRANSACTION_STATUS", "error");
          commit("SET_LOADING", false);
        });
    },

    stkStatus: ({ commit, dispatch, state }, payload) => {
      call("get", CheckoutConstant.stkStatus(payload))
        .then((res) => {
          commit("SET_TRANSACTION", res.data.data);
          console.log("status", res.data.data.status);

          if (state.statusTries <= 30) {
            if (res.data.data.status === "pending") {
              setTimeout(function () {
                commit("SET_STATUS_TRIES");
                dispatch("stkStatus", res.data.data.CheckoutRequestID);
              }, 3000);
            } else {
              commit("SET_LOADING", false);
              commit("SET_TRANSACTION_STATUS", res.data.data.status);
            }
          } else {
            commit("SET_TRANSACTION_STATUS", "timeout");
            commit("SET_LOADING", false);
          }
        })
        .catch((error) => {
          commit("SET_MESSAGE", error.response.data.message);
          commit("SET_TRANSACTION_STATUS", "error");
          commit("SET_LOADING", false);
        });
    },

    chequePayment: ({ commit }, payload) => {
      commit("SET_TRANSACTION_STATUS", "pending");
      commit("SET_LOADING", true);
      call("post", CheckoutConstant.cheque, payload)
        .then((res) => {
          commit("SET_TRANSACTION", res.data.data);
          commit("SET_LOADING", false);
          commit("SET_MESSAGE", "success");
          commit("SET_TRANSACTION_STATUS", "success");
        })
        .catch((error) => {
          commit("SET_MESSAGE", error.response.data.message);
          commit("SET_LOADING", false);
          commit("SET_TRANSACTION_STATUS", "error");
        });
    },

    cardPayment: ({ commit }, payload) => {
      commit("SET_TRANSACTION_STATUS", "pending");
      call("post", CheckoutConstant.cardPayments, payload)
        .then((res) => {
          commit("CARD_RESP", res.data.data);
          commit("SET_TRANSACTION_STATUS", "success");
        })
        .catch((error) => {
          commit("SET_MESSAGE", error.response.data.message);
          commit("SET_TRANSACTION_STATUS", "error");
        });
    },

    getBalance: ({ commit }, payload) => {
      const { isBatch,...restPayload } = payload;
      if (isBatch) {
        console.log("isBatch: ", isBatch);
        return call("get", CheckoutConstant.getBalance(restPayload));
      }else {
        call("get", CheckoutConstant.getBalance(restPayload))
        .then((res) => {
          commit("SET_BALANCE", res.data.data);
        })
        .catch((error) => {
          commit("SET_MESSAGE", error.response.data.message);
        });
      }
    },

    confirmPayment: ({ commit }, payload) => {
      commit("SET_LOADING", true);
      commit("SET_TRANSACTION_STATUS", "pending");
      call("post", CheckoutConstant.confirmPayment, payload)
        .then((res) => {
          commit("SET_TRANSACTION", res.data.data);
          commit("SET_LOADING", false);
          commit("SET_MESSAGE", "success");
          commit("SET_TRANSACTION_STATUS", "success");
        })
        .catch((error) => {
          commit("SET_MESSAGE", error.response.data.message);
          commit("SET_LOADING", false);
          commit("SET_TRANSACTION_STATUS", "error");
        });
      },
      getPesaflowIfram({commit}, payload) {
        commit("SET_TRANSACTION_STATUS", "pending");
      call("post", CheckoutConstant.getPesaflowIframe, payload)
        .then((res) => {
          commit("SET_IFRAME", res.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_MESSAGE", error.response.data.message);
          commit("SET_LOADING", false);
          commit("SET_TRANSACTION_STATUS", "error");
        });
      }
  },
};
